import { atom } from 'recoil';

export const failedMessages = atom({
  key: 'FailedMessages',
  default: {}
});
